<div class="container-fluid ">
    @if (Strategy) {
    <div class="row justify-content-center">
        <h2 class="text-center ">Planification de mesures pour {{Strategy.Portfolio.SamplingPoint.Name}}</h2>
        <h4 class="text-center"> {{Strategy.PartnerName}} </h4>
        <h4 class="text-center"> {{Strategy.Portfolio.SamplingPoint.ZipCode}} {{Strategy.Portfolio.SamplingPoint.City}}
        </h4>
        @if (!Strategy.ContexteHorsStrategie || IsDispatch) {
        <h4 class="text-center"> Stratégie {{Strategy.Id}}</h4>
        }
        <!-- {{Model.Status}} -->
        <!-- <h4 class="text-center "> {{Strategy.Portfolio.SamplingPoint.Name}}</h4> -->

        @if (!Strategy.ContexteHorsStrategie || IsDispatch) {
        <h4 class="text-center mb-3"> Devis N°{{Strategy.Portfolio.QuotationCode}}</h4>
        }
        @if (IsDispatch) {
        <h1 class="text-center" style="color: red;">
            @if (Model.IsQuotationExpired) {
            <div>Le devis arrive à expiration, veuillez le mettre à jour.</div>
            }
            @if (Model.IsSamplingPointMissing) {
            <div>Le point de prélèvement n'existe pas. Veuillez ajouter un contrat sur la stratégie.</div>
            }
            @if (Model.IsQuotationMissing) {
            <div>Veuillez ajouter un devis dans la stratégie.</div>
            }
            @if (Model.IsClientBlocked) {
            <div>Le client est bloqué.</div>
            }
        </h1>
        }
        <div class="col-12 col-md-10">
            <div class="row justify-content-center align-items-center">
                <mat-form-field class="col-auto">
                    <input matInput placeholder="Date d'intervention souhaitée" [(ngModel)]="Model.RequiredOn" [matDatepicker]="picker" (focus)="picker.open()" [min]="MinDate"
                        (dateChange)="dateChanged($event)" [disabled]="CanChangeRequiredOn()" required>
                    <mat-datepicker #picker di></mat-datepicker>
                </mat-form-field>
                @if (IsDispatch) {
                <mat-checkbox class="col-auto" [(ngModel)]="Model.IsDeposeJ0"> Dépose à J0 ?</mat-checkbox>
                }
                <mat-checkbox class="col-auto" [(ngModel)]="WithStrictHours" [disabled]="!Model.RequiredOn" (change)="onChange($event.checked)"> Besoin de
                    préciser un horaire ?</mat-checkbox>
                @if (!WithStrictHours) {
                <div class="col-auto"></div>
                }
                @if (WithStrictHours) {
                <mat-form-field class="col-auto">
                    <input matInput placeholder="Début" [ngxTimepicker]="minTimepicker" [format]="24" [value]="minInterventionTime" readonly>
                    <ngx-material-timepicker #minTimepicker (timeSet)="addTimeToMinInterventionDate($event)" [defaultTime]="minInterventionTime"></ngx-material-timepicker>
                </mat-form-field>
                }
                @if (WithStrictHours) {
                <mat-form-field class="col-auto">
                    <input matInput placeholder="Fin" [ngxTimepicker]="maxTimepicker" [format]="24" [value]="maxInterventionTime" readonly>
                    <ngx-material-timepicker #maxTimepicker (timeSet)="addTimeToMaxInterventionDate($event)" [defaultTime]="maxInterventionTime"></ngx-material-timepicker>
                </mat-form-field>
                }
            </div>
            @if (IsDispatch && Specificity) {
            <div class="row justify-content-center my-1 ">
                <div class="col">
                    <div class="p-3 border rounded selected text-center ">
                        <h3 class="fw-bold">Spécificité client</h3>
                        <div>
                            {{Specificity}}
                        </div>
                    </div>
                </div>
            </div>
            }
            @if (IsDispatch) {
            <div class="row g-0 justify-content-center">
                <mat-form-field class="">
                    <mat-chip-grid multiple #chipList>
                        @for (comp of Model.CompetenceList; track comp) {
                        <mat-chip selected="" [removable]="true" (removed)="removeCompetence(comp)">
                            {{comp.Name}}
                            <button matChipRemove>
                                <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                            </button>
                        </mat-chip>
                        }
                        <input #compInput placeholder="Compétences nécéssaires..." [formControl]="compCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList">
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedComp($event)">
                        @for (c of AvailableMasterCompetenceList; track c) {
                        <mat-option [value]="c">
                            {{c.Name}}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            }
            <div class="row g-0 justify-content-center">
                <mat-form-field class="col pe-3">
                    <mat-select placeholder="Contact chantier" [(ngModel)]="Model.SiteContact" [compareWith]="compareUserWith">
                        @for (contact of AvailableContactList; track contact) {
                        <mat-option [value]="contact">
                            @if (contact.Phone) {
                            <span>{{contact.FirstName}} {{contact.LastName}} - {{contact.Phone}}</span>
                            } @else {
                            <span>{{contact.FirstName}} {{contact.LastName}} </span>
                            }
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <div class="col-auto">
                    <button mat-mini-fab color="accent" (click)="openContactDialog()">
                        <mat-icon class="material-symbols-outlined"> add</mat-icon>
                    </button>
                </div>
            </div>
            <!-- <div class="row justify-content-center align-items-center">
        <mat-form-field class="col">
          <mat-select placeholder="Type de mesure" [(ngModel)]="SelectedUsage" (selectionChange)="getZoneOrProcessAvailable()" [compareWith]="compareWith">
            <mat-option *ngFor="let u of UsageList; let i = index" [value]="i + 1">
              <span>{{u}} </span>
            </mat-option>
            <mat-option [value]="0">
              <span> Processus </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col">
          <mat-select placeholder="Zone / Processus" [(ngModel)]="SelectedParent" (selectionChange)="getMeasureAvailableForThatZoneProcess()"
            [compareWith]="compareWith">
            <mat-option *ngFor="let m of ZoneProcessList" [value]="m">
              <span>{{m.ParentName}} </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col">
          <mat-select placeholder="Mesures" [(ngModel)]="SelectedMeasureList" multiple panelClass="custom" [compareWith]="compareWith">
            <mat-option *ngFor="let m of MeasureList" [value]="m">
              <span>{{m.MeasureReferenceDesignation}} {{m.MeasureReferenceName}} </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="WithBattery">
          Batterie*
        </mat-slide-toggle>
        <mat-slide-toggle class="col-6 col-md-auto" labelPosition="after" [(ngModel)]="WithExpressDelay">
          Express*
        </mat-slide-toggle>
        <button fxShow fxHide.lt-md appPreventDoubleClick mat-mini-fab color="accent" (throttledClick)="addToIntervention()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
        </button>
        <button fxShow fxShow fxHide.gt-sm appPreventDoubleClick class="col-12 col-md-2 mt-4" mat-raised-button color="accent" (throttledClick)="addToIntervention()">
          <mat-icon class="material-symbols-outlined">add</mat-icon> Ajouter
        </button>
      </div>
    </div> -->
            @if (!Strategy.ContexteHorsStrategie || IsDispatch) {
            <div class="row my-3 text-center">
                <button appPreventDoubleClick mat-raised-button color="accent" (throttledClick)="openStandardBox()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon> Ajouter une mesure
                </button>
            </div>
            }
            @if (!Strategy.ContexteHorsStrategie || IsDispatch) {
            <div class="row my-3">
                <table #table mat-table [dataSource]="StandardMeasureList" class="mat-elevation-z8">
                    <ng-container matColumnDef="color">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> </th>
                        <td mat-cell *matCellDef="let element" class="text-center" [style.background-color]="getColorForPoseDeposeOP(element)"
                            [matTooltip]="getLabelForPoseDeposeOP(element)"> </td>
                    </ng-container>
                    <ng-container matColumnDef="measure">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Nom Zone / Process </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.ParentName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Mesure </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.MeasureReferenceName}}
                            @if (Strategy.IsFDX && element.ZoneUsage === EZoneUsage.Environmental) {
                            <span> - {{getFrequencyLabel(element.Frequency)}}</span>
                            }
                            {{getProcessDisclaimer(element)}}
                        </td>
                    </ng-container>
                    @if (IsDispatch) {
                    <ng-container matColumnDef="edi">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> EDI Analysis Number </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.EDIAnalysisNumber}} </td>
                    </ng-container>
                    }
                    <ng-container matColumnDef="battery">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Batterie* </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.PumpWithBattery) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="express">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Express* </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.Rush) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    @if (IsDispatch) {
                    <ng-container matColumnDef="hasFan">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Ventillo </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.HasFan) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    }
                    @if (IsDispatch) {
                    <ng-container matColumnDef="accredited">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Accréditée </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.IsAccredited) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    }
                    <!--
          <ng-container matColumnDef="samplingId">
            <th mat-header-cell *matHeaderCellDef class="text-center"> Id </th>
            <td mat-cell *matCellDef="let element" class="text-center"> {{element.SamplingId}} </td>
          </ng-container> -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (IsDispatch && IsProcess(element.MeasureReferenceCode)) {
                            <button mat-icon-button [color]="element.AreaMapName ? 'accent' : 'primary'" (click)="$event.stopPropagation();openMapSelection(element)">
                                <mat-icon class="material-symbols-outlined">map</mat-icon>
                            </button>
                            }
                            @if (IsDispatch) {
                            <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="EDI" (throttledClick)="openEditTextBoxForEDINumber(element)">
                                <mat-icon class="material-symbols-outlined">description</mat-icon>
                            </button>
                            }
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openMeasureEditionBox(element, true)">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="$event.stopPropagation();deleteMeasure(element)">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <!-- Disclaimer column -->
                    <ng-container matColumnDef="disclaimer">
                        <td mat-footer-cell *matFooterCellDef colspan="5">
                            <div class="fst-italic text-start"><small>(*) Facturation supplémentaire conformément au
                                    devis</small></div>
                            <div class="fst-italic text-start"><small>(1) La commande d'une mesure opérateur entraîne
                                    l'ajout d'un matériau et d'une MEST. Si vous ne souhaitez pas les commander, vous
                                    pouvez les enlever. </small></div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row class="clickable" *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr mat-footer-row *matFooterRowDef="['disclaimer']"></tr>
                </table>
            </div>
            }

            <div class="row my-3 text-center">
                <button appPreventDoubleClick mat-raised-button color="accent" (throttledClick)="openComplementaryBox()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon> Mesure complémentaire amiante
                </button>
            </div>
            <div class="row my-3">
                <table #ctable mat-table [dataSource]="ComplementaryMeasureList" class="mat-elevation-z8">
                    <ng-container matColumnDef="color">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> </th>
                        <td mat-cell *matCellDef="let element" class="text-center" [style.background-color]="getColorForPoseDeposeOP(element)"
                            [matTooltip]="getLabelForPoseDeposeOP(element)"> </td>
                    </ng-container>
                    <ng-container matColumnDef="plan">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Plan </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.AreaMapName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="mesure">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Mesure </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.MeasureReferenceName}}
                            {{getProcessDisclaimer(element)}}</td>
                    </ng-container>
                    @if (IsDispatch) {
                    <ng-container matColumnDef="edi">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> EDI Analysis Number </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.EDIAnalysisNumber}} </td>
                    </ng-container>
                    }
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Description </th>
                        <td mat-cell *matCellDef="let element" class="text-center"> {{element.ParentDescription}} </td>
                    </ng-container>
                    <ng-container matColumnDef="battery">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Batterie* </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.PumpWithBattery) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="express">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Express* </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.Rush) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    @if (IsDispatch) {
                    <ng-container matColumnDef="hasFan">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Ventillo </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            @if (element.HasFan) {
                            <mat-icon class="material-symbols-outlined">done</mat-icon>
                            }
                        </td>
                    </ng-container>
                    }
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (IsDispatch && IsProcess(element)) {
                            <button mat-icon-button [color]="element.AreaMapName ? 'accent' : 'primary'" (click)="$event.stopPropagation();openMapSelection(element)">
                                <mat-icon class="material-symbols-outlined">map</mat-icon>
                            </button>
                            }

                            @if (IsDispatch) {
                            <button appPreventDoubleClick mat-icon-button color="primary" matTooltip="EDI" (throttledClick)="openEditTextBoxForEDINumber(element)">
                                <mat-icon class="material-symbols-outlined">description</mat-icon>
                            </button>
                            }

                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openMeasureEditionBox(element)">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            </button>

                            <button mat-icon-button color="primary" (click)="$event.stopPropagation();deleteMeasureComplementary(element)">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <!-- Disclaimer column -->
                    <ng-container matColumnDef="disclaimer">
                        <td mat-footer-cell *matFooterCellDef colspan="5">
                            <div class="fst-italic text-start"><small>(*) Facturation supplémentaire conformément au
                                    devis</small></div>
                            <div class="fst-italic text-start"><small>(1) La commande d'une mesure opérateur entraîne
                                    l'ajout d'un matériau et d'une MEST. Si vous ne souhaitez pas les commander, vous
                                    pouvez les enlever. </small></div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="cdisplayedColumns; sticky: true"></tr>
                    <tr mat-row class="clickable" *matRowDef="let row; columns: cdisplayedColumns;"></tr>
                    <tr mat-footer-row *matFooterRowDef="['disclaimer']"></tr>
                </table>
            </div>

            <div class="row text-center fw-bold">
                <div class="col-6 mb-3">
                    <div class="border rounded-1 p-3 exotic-box">
                        <div class="row justify-content-center">
                            prélèvement surfacique plomb
                        </div>
                        <div class="row justify-content-center align-items-center">
                            <button type="button" class="col-auto circle my-3"
                                (click)="openExoticMeasureCountDialog(EMeasureParentType.Lingette, LingetteMeasureList, 'prélèvements surfaciques plomb')"
                                aria-label="Modifier le nombre de prélèvements surfaciques plomb">
                                <div>{{LingetteMeasureList.length}}</div>
                            </button>
                            <div class="row">
                                <div class="col-auto">
                                    <button appPreventDoubleClick mat-raised-button (throttledClick)="openMapSelectionForLingetteOrMassif(EAreaMapType.PlanDeLingette)">
                                        Ajouter un plan <mat-icon class="material-symbols-outlined">add</mat-icon>
                                    </button>
                                </div>
                                <div class="col">

                                    <mat-chip-set multiple #chipList>
                                        <div class="row justify-content-center align-content-center">
                                            @for (areaMap of Model.LingetteAreaMapTerrainList; track areaMap) {
                                            <div class="col-auto">
                                                <mat-chip highlighted color="primary" [removable]="true" (removed)="removeLingette(areaMap)">

                                                    <div class="row align-items-center align-content-center">
                                                        <div class="col-auto my-auto d-flex justify-content-center align-items-center pe-0">
                                                            <mat-icon class="material-symbols-outlined">map</mat-icon>
                                                        </div>
                                                        <div class="col">{{areaMap.Legend}}</div>
                                                    </div>
                                                    <button matChipRemove>
                                                        <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                                                    </button>
                                                </mat-chip>
                                            </div>
                                            }
                                        </div>
                                    </mat-chip-set>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="border rounded-1 p-3 exotic-box">
                        <div class="row justify-content-center">
                            Matériaux
                        </div>
                        <button type="button" class="col-auto circle my-3" (click)="openExoticMeasureCountDialog(EMeasureParentType.Massif, MassifMeasureList, 'matériaux')"
                            aria-label="Modifier le nombre de matériaux">
                            <div>{{MassifMeasureList.length}}</div>
                        </button>

                        <div class="row">
                            <div class="col-auto">
                                <button appPreventDoubleClick mat-raised-button (throttledClick)="openMapSelectionForLingetteOrMassif(EAreaMapType.PlanMassif)">
                                    Ajouter un plan <mat-icon class="material-symbols-outlined">add</mat-icon>
                                </button>
                            </div>
                            <div class="col">

                                <mat-chip-set multiple #chipList>
                                    <div class="row justify-content-center align-content-center">
                                        @for (areaMap of Model.MassifAreaMapTerrainList; track areaMap) {
                                        <div class="col-auto">
                                            <mat-chip highlighted color="primary" [removable]="true" (removed)="removeMassif(areaMap)">

                                                <div class="row align-items-center align-content-center">
                                                    <div class="col-auto my-auto d-flex justify-content-center align-items-center pe-0">
                                                        <mat-icon class="material-symbols-outlined">map</mat-icon>
                                                    </div>
                                                    <div class="col">{{areaMap.Legend}}</div>
                                                </div>
                                                <button matChipRemove>
                                                    <mat-icon class="material-symbols-outlined">cancel</mat-icon>
                                                </button>
                                            </mat-chip>
                                        </div>
                                        }
                                    </div>
                                </mat-chip-set>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="border rounded-1 p-3 exotic-box">
                        <div class="row justify-content-center">
                            MEST
                        </div>
                        <div class="row justify-content-center align-items-center">

                            <button type="button" class="col-auto circle my-3" (click)="openExoticMeasureCountDialog(EMeasureParentType.Eau, EauMeasureList, 'MEST')"
                                aria-label="Modifier le nombre de MEST">
                                <div>{{EauMeasureList.length}}</div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="border rounded-1 p-3 exotic-box">
                        <div class="row justify-content-center">
                            Adduction
                        </div>
                        <div class="row justify-content-center align-items-center">

                            <button type="button" class="col-auto circle my-3"
                                (click)="openExoticMeasureCountDialog(EMeasureParentType.AdductionAir, AdductionMeasureList, 'adductions')"
                                aria-label="Modifier le nombre d’adductions">
                                <div>{{AdductionMeasureList.length}}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <mat-form-field class="col">

                    <mat-select placeholder="Catégories / Autres polluants" [(ngModel)]="SelectedGroup" [compareWith]="compareUserWith" (selectionChange)="getMeasureOfThatGroup()">
                        @for (m of AvailableGenericList; track m) {
                        <mat-option [value]="m">
                            <span class="fw-bold">{{m.GroupName}} </span>
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col">

                    <mat-select placeholder="Prestation" [(ngModel)]="SelectedGeneric" [compareWith]="compareUserWith">
                        @for (m of AvailableMeasureByGroupList; track m) {
                        <mat-option [value]="m">
                            <span class=""> {{m.MeasureReferenceName}}</span>
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <button appPreventDoubleClick mat-mini-fab color="primary" (throttledClick)="addGeneric()" [disabled]="!SelectedGeneric">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                </button>
            </div>

            <div class="row">
                @for (m of GenericList; track m) {

                <div class="col-3 h-100">
                    <div class="border rounded-1 p-3" [class]="m.IsPrestationAnnexe ? 'annexe' : 'exotic-box'">
                        <div class="row justify-content-center fw-bold">
                            {{m.GroupName}}
                        </div>
                        <div class="row mx-auto justify-content-center  my-3">
                            <div>{{m.MeasureReferenceName}}</div>
                        </div>
                        <div class="row justify-content-center text-center">
                            <button appPreventDoubleClick class="col-auto ms-1" mat-mini-fab color="primary" color="warn" (click)="removeGeneric(m)">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                }
            </div>

            <div class="row no-gutters justify-content-center my-3">
                <mat-form-field class="col">
                    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
                        placeholder="Informations complémentaires (Accès, formation, compétences ...)" [(ngModel)]="Model.Comment"></textarea>
                </mat-form-field>
            </div>
            @if (IsDispatch) {
            <div class="row no-gutters justify-content-center my-3">
                <div class="col">
                    <mat-form-field class="w-100">
                        <input matInput placeholder="EDI Order Number" [(ngModel)]="Model.EDIOrderNumber">
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <input matInput placeholder="Durée (minutes)" [(ngModel)]="Model.Duration">
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-select placeholder="Agence de prélèvement" [(ngModel)]="Model.SamplingAgencyName">
                            @for (a of AgencyList; track a) {
                            <mat-option [value]="a.Name">
                                <span>{{a.Name}} </span>
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            }
            @if (IsDispatch) {
            <div class="row no-gutters justify-content-center my-3">
                <div class="col">
                    <mat-form-field class="w-100">
                        <textarea matInput placeholder="Commentaire du Dispatch" [(ngModel)]="Model.DispatchComment"></textarea>
                    </mat-form-field>
                </div>
            </div>
            }
            <div class="card mt-3">
                <h5 class="card-header">
                    <span class="row">
                        <span class="col-auto">Documents</span>
                        <mat-icon class="col-auto p-0 material-symbols-outlined" matTooltip="Bon de commande">help</mat-icon>
                    </span>
                </h5>
                <div class="card-body">
                    <div class="row">
                        @if (Model.OrderFileName) {
                        <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                            <div class="m-1 border rounded">
                                <div class="justify-content-center text-center">
                                    <div class="row justify-content-around">
                                        <!-- <div style="height: 10px; width: 40px;"></div> -->
                                        <button class="icon-button-large" mat-icon-button color="primary">
                                            <mat-icon class="material-symbols-outlined">description</mat-icon>
                                        </button>
                                        <!-- <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deleteDocument(d)">
                    <mat-icon class="material-symbols-outlined">clear</mat-icon>
                  </button> -->
                                    </div>
                                    <div class="row mb-1">
                                        <div>{{Model.OrderFileName}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        @if (!Model.OrderFileName) {
                        <div class="col-12 col-sm-6 col-md-4 col-xl-4">
                            <div class="m-1 border rounded">
                                <div class="justify-content-center text-center">
                                    <div class="row">
                                        <button class="col icon-button-large" appPreventDoubleClick mat-icon-button color="accent" (throttledClick)="openDocumentDialog()"
                                            onclick="this.blur()">
                                            <mat-icon class="material-symbols-outlined">note_add</mat-icon>
                                        </button>
                                    </div>
                                    <div class="row mb-1">
                                        <div>Nouveau</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center my-3">
            @if (!IsCreation) {
            <button appPreventDoubleClick class="col-3 " mat-raised-button color="warn" (throttledClick)="deleteOrder(Model)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                Supprimer
            </button>
            }
            <button appPreventDoubleClick class="col-3 mx-3" mat-raised-button color="accent" (throttledClick)="checkAndValidateOrder()" [disabled]="!CanOrder()">
                <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
                {{ IsCreation ? 'Confirmer' : 'Modifier'}}
            </button>
            @if (IsCreation) {
            <button appPreventDoubleClick class="col-3" mat-raised-button color="primary" (throttledClick)="checkAndValidateOrder(true)" [disabled]="!CanOrder()">
                <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
                {{ IsCreation ? 'Confirmer' : 'Modifier'}} et continuer
            </button>
            }
        </div>
    </div>
    }
</div>